<script setup>
import {computed} from "vue";
import InertiaPagination from "@/Components/InertiaPagination.vue";
import EmitsPagination from "@/Components/EmitsPagination.vue";

const props = defineProps({
    data: {
        type: [Object, null],
        required: false,
        default: null,
    },
    mode: {
        type: String,
        required: false,
        default: 'inertia',
    }
});

const emit = defineEmits(['changed']);

const mode = computed(() => {
    return !['inertia', 'emits'].includes(props.mode)
        ? 'inertia'
        : props.mode;
});
</script>

<template>
    <InertiaPagination v-if="mode === 'inertia'" :data="data"/>
    <EmitsPagination v-if="mode === 'emits'"
        :data="data"
        @changed="(page) => { emit('changed', page); }"
    />
</template>
